import type {StateCreator} from 'zustand';
import type {AssignmentSettingsFormSchemaType} from 'client/components/ContentDiscovery/AssignmentSettings/AssignmentSettingsForm/AssignmentSettingsForm.schema';
import type {ContentDiscoveryStoreState} from 'client/components/ContentDiscovery/store/ContentDiscoveryStore.types';

type SettingsFormState = {
  formData: AssignmentSettingsFormSchemaType | null;
  settingsValidationError: boolean;
  hasDueDate: boolean;
};

type SettingsFormActions = {
  setFormData: (formData: AssignmentSettingsFormSchemaType) => void;
  setSettingsValidationError: (error: boolean) => void;
  setHasDueDate: (hasDueDate: boolean) => void;
  reset: () => void;
};

const initialState: SettingsFormState = {
  formData: null,
  settingsValidationError: false,
  hasDueDate: false
};

export type SettingsFormSlice = SettingsFormState & SettingsFormActions;

export const createSettingsFormSlice: StateCreator<
  ContentDiscoveryStoreState,
  [['zustand/immer', never]],
  [],
  SettingsFormSlice
> = (set, _): SettingsFormSlice => ({
  ...initialState,
  setFormData: async (formData) => {
    set((state) => {
      state.settingsForm.formData = formData as AssignmentSettingsFormSchemaType;
    });
  },
  setSettingsValidationError: async (error) => {
    set((state) => {
      state.settingsForm.settingsValidationError = error;
    });
  },
  setHasDueDate: async (hasDueDate) => {
    set((state) => {
      state.settingsForm.hasDueDate = hasDueDate;
    });
  },
  reset: () => {
    set((state) => {
      state.settingsForm = {...state.settingsForm, ...initialState};
    });
  }
});
